export default __webpack_public_path__ + "static/animation-img3-90fccc1c5465e58c1c1c09057472ad5b.webp";